export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q02_a.4bbfd6e6.png";